import { GridFilterItem } from '@mui/x-data-grid-pro';

const UNASSIGNED_FILTER: GridFilterItem = {
	id: 50001,
	field: 'isAssignedJob',
	operator: 'equals',
	value: 'false'
};

const ON_ROUTE_NO_JOB_FILTER: GridFilterItem = {
	id: 50002,
	field: 'isOnLastJob',
	operator: 'equals',
	value: 'true'
};

const HAZMAT_ENDORSED_FILTER: GridFilterItem = {
	id: 50003,
	field: 'hazmatExpirationDate',
	operator: '> Today'
};

export { UNASSIGNED_FILTER, ON_ROUTE_NO_JOB_FILTER, HAZMAT_ENDORSED_FILTER };
